import { combineReducers } from 'redux';

import apiReducer from './common/api/apiReducer';
import formsReducer from './common/api/formsReducer';
import audioReducer from './common/audio/audioReducer';
import alexReducer from './common/alex/AlexReducer';
import avatarReducer from './common/avatar/avatarReducer';
import playlistReducer from './common/playlist/playlistReducer';
import questionsReducer from './common/questions/questionsReducer';
import timeTrackingReducer from './common/timeTracking/timeTrackingReducer';
import rctReducer from './rct/rctReducer';
import resultReducer from './common/api/resultReducer';
import screenReducer from './common/screen/screenReducer';
import stimulusButtonReducer from './common/stimulus/stimulusButtonReducer';
import userReducer from './common/user/userReducer';
import dazeReducer from './daze/dazeReducer';
import trcReducer from './trc/trcReducer';
import vocabReducer from './vocab/vocabReducer';
import spellingReducer from './spelling/spellingReducer';
import ranReducer from './ran/ranReducer';
import ipsReducer from './ips/ipsReducer';
import nwReducer from './nw/nwReducer';
import pbReducer from './pb/pbReducer';
import mazeReducer from './maze/mazeReducer';
import resumeReducer from './common/resume/resumeReducer';
import lnReducer from './ln/LNReducer';
import recordingReducer from './common/recording/recordingReducer';
import wrReducer from './wr/wrReducer';
import lcReducer from './lc/lcReducer';
import secureBrowserReducer from './common/secureBrowser/secureBrowserReducer';

export const appReducers = {
    api: apiReducer,
    audio: audioReducer,
    alex: alexReducer,
    avatar: avatarReducer,
    playlist: playlistReducer,
    questions: questionsReducer,
    timeTracking: timeTrackingReducer,
    rct: rctReducer,
    result: resultReducer,
    screen: screenReducer,
    stimulus: stimulusButtonReducer,
    user: userReducer,
    daze: dazeReducer,
    maze: mazeReducer,
    trc: trcReducer,
    vocab: vocabReducer,
    spelling: spellingReducer,
    ln: lnReducer,
    ran: ranReducer,
    ips: ipsReducer,
    nw: nwReducer,
    pb: pbReducer,
    resume: resumeReducer,
    forms: formsReducer,
    recording: recordingReducer,
    wr: wrReducer,
    lc: lcReducer,
    secureBrowser: secureBrowserReducer,
};

const rootReducer = combineReducers(appReducers);

export default rootReducer;
